import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CaptionCellParams } from '../../models/caption-cell.model';

/** An AG Grid cell showing its value followed by a small grey caption from the column's `captionFor`. */
@Component({
  selector: 'gains-caption-cell',
  standalone: false,
  templateUrl: './gains-caption-cell.component.html',
  styleUrl: './gains-caption-cell.component.scss'
})
export class GainsCaptionCellComponent<TData = unknown> implements ICellRendererAngularComp {
  protected text = '';
  protected caption = '';

  agInit(params: CaptionCellParams<TData>): void {
    this.show(params);
  }

  refresh(params: CaptionCellParams<TData>): boolean {
    this.show(params);
    return true;
  }

  private show(params: CaptionCellParams<TData>): void {
    this.text = params.valueFormatted ?? params.value ?? '';
    this.caption = params.data === undefined ? '' : params.captionFor(params.data);
  }
}
